<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;">
        <router-view></router-view>
        <el-button size="small" type="danger" v-if="activeTab === 'newRefund'" icon="el-icon-delete"
                   @click="refund()">批量退票</el-button>
        <el-button size="small" type="success" v-if="activeTab === 'newRefund'"
                   @click="cancelRefund()">批量取消退票</el-button>
      </div>
      <export-components :apiFunction="exportInvoice" :requestData="getSearch({...sendData[activeTab]})" :option="option"
              @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
                    :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)"
             @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true" :key="activeTab"
             :table-col-check="{isShow:true,name:'Refund_Info3' + activeTab}" :isShowRowSelection="true"
             ref="wMyTable" :page="page" @pageChange="handlePagePagination">
      <template slot="operation" slot-scope="{text,record}">
        <el-button size="mini" type="danger" v-if="record.invoiceStatus === 'PENDING_REFUND'" icon="el-icon-delete"
                   @click="refund(record)">退票</el-button>
        <el-button size="mini" type="success" v-if="record.invoiceStatus === 'PENDING_REFUND'"
                   @click="cancelRefund(record)">取消退票</el-button>
        <el-button size="mini" style="color:#ffffff;background-color: #779221" color="#ffffff" v-if="record.appendix"
                   icon="el-icon-download" @click="download(record)">下载发票</el-button>
      </template>
      <template slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </template>
      <template slot="connectedFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="sameDayFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </template>
      <template slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
           style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
      <template slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </template>
      <template slot="refundAuditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
                  :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
                               :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </template>
      <template slot="invoiceStatus" slot-scope="{text,record}">
        <el-tag :type="getInvoiceColor(text,'tagType')"
                :style="{color: getInvoiceColor(text,'color'),'background-color':getInvoiceColor(text,'backgroundColor')}">
          {{getInvoiceColor(text,'name')}}</el-tag>
      </template>
      <template slot="filterInvoice" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
           style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='应收款'>应收款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待开票'>待开票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已回款'>已回款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待退票'>待退票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='退票成功'>退票成功</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='部分到款'>部分到款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='取消开票'>取消开票</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
                    @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索
          </a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消
          </a-button>
        </div>
      </template>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
                        @submit="closeShowContact"></customer-user-info>
  </div>
</template>

<script>
import {attachmentTickets, exportInvoice, getTicketsPage, refundSuccess} from "@/api/dilivery/tickets";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTable from "@/components/ExFoldTable.vue";
import ExFoldCell from "@/components/ExFoldCell.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import {refundInvoice} from "@/utils/data/tableCol/info/refund/refundInvoice";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import {viewDetailIcon} from "@/utils/icon";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import {getUserPage} from "@/api/dilivery/customer/user";
import {getInvoiceColor, getStatusColor} from "@/color";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { cancelRefund } from "@/api/dilivery/record";
const baseURL = process.env.VUE_APP_BASE_API


export default {
  name: "RefundInfo",
  components: {CustomerUserInfo, ExportComponents, PictureLoading, ExFoldCell,ExFoldTableCell, ExFoldTable, TableHeadNote},
  mixins: [tableOperationMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'all', showBadge: false },
        { label: '待退票记录', name: 'newRefund', showBadge: true },
        { label: '历史退票记录', name: 'refundHistory', showBadge: false },
      ],
      sendData: {
        all: { "query#invoiceStatus.IN": "PENDING_REFUND,REFUND_SUCCESS" },
        newRefund: { "query#invoiceStatus.EQ": "PENDING_REFUND" },
        refundHistory: { "query#invoiceStatus.EQ": "REFUND_SUCCESS" },
      },
      pageTotal: { all: 0, newRefund: 0, refundHistory: 0 },
      activeTab: 'newRefund',
      loading: true,
      viewDetailIcon: viewDetailIcon,
      contactInfo: [],
      showContactInfo: false,
      option: [
        { label: '退票申请时间', value: 'refundTime' },
        { label: '退票日期', value: 'refundDate' },
        { label: '退票审核日期', value: 'operatingTime' },
        { label: '开票日期', value: 'invoiceDate' },
        { label: '创建时间', value: 'createTime' },
      ],
      showType: '',
    }
  },
  computed: {
    columns() {
      let cols = refundInvoice([] || {})
      if (this.activeTab === "newRefund") {
        return JSON.parse(JSON.stringify(cols.filter(item => !['operatingPersonName'].includes(item.key))))
      } else {
        return JSON.parse(JSON.stringify(cols))
      }
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    getStatusColor,
    getInvoiceColor,
    exportInvoice,
    loadAllTabTotals() {
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getTicketsPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    async download(row) {
      try {
        let url = `${baseURL}/invoice-info/attachment/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showContact(contactName) {
      let data = { "query#contactName.IN": contactName.join(',') }
      getUserPage({}, data).then(res => {
        if (res.code === 200) {
          this.contactInfo = res.data.records
          this.showContactInfo = true
        } else {
          this.showContactInfo = false
        }
      }).catch(err => {
        this.showContactInfo = false
      })
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getTicketsPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
        }
      }).catch(() => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (['refundAuditStatus','statusType'].includes(item.key)) {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (item.key === 'invoiceStatus') {
          if (item.value === '待审核') {
            value = 'PENDING_AUDIT'
          } else if (item.value === '待开票') {
            value = 'PENDING_INVOICE'
          } else if (item.value === '应收款') {
            value = 'RECEIVABLES'
          } else if (item.value === '已回款') {
            value = 'PAYMENT'
          } else if (item.value === '退票成功') {
            value = 'REFUND_SUCCESS'
          } else if (item.value === '部分到款') {
            value = 'PARTIAL_ARRIVAL'
          } else if (item.value === '取消开票') {
            value = 'CANCEL_INVOICING'
          } else {
            value = 'PENDING_REFUND'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        }
        if (['invoiceRecordNumber','statusType','contractNumber','saleName','invoicingPrincipal','invoiceTitle','billingUnitName','contactName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    refund(row) {
      let ids = this.selectable.map(item => item.id)
      if (row && row.id) {
        ids = [row.id]
      } else {
        if (ids.length <= 0) {
          this.$messageUi.error('批量退票会筛选待退票发票，请勾选要批量退票的数据')
          return
        }
      }
      this.$confirmUi('确定要退票吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = { "ids": ids.join(',') }
        refundSuccess(param).then(res => {
          if (res.code === 200) {
            this.$store.commit('right/setChangeRed', true)
            this.$messageUi({ type: 'success', message: '退票成功!' })
            this.selectable = []
            this.getData('search')
          }
        }).catch(err => {})
      }).catch(() => {})
    },
    cancelRefund(row) {
      let ids = this.selectable.map(item => item.id)
      if (row && row.id) {
        ids = [row.id]
      } else {
        if (ids.length <= 0) {
          this.$messageUi.error('批量取消退票会筛选待退票发票，请勾选要批量取消退票的数据')
          return
        }
      }
      this.$confirmUi('确定要取消退票吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let param = { "ids": ids.join(',') }
        cancelRefund(param).then(res => {
          if (res.code === 200) {
            this.$store.commit('right/setChangeRed', true)
            this.$messageUi({ type: 'success', message: '取消退票成功!' })
            this.selectable = []
            this.getData('search')
          }
        }).catch(err => {})
      }).catch(() => {})
    },
  }
}
</script>

<style scoped>
</style>
